import isIOS from '@anm/helpers/is/isIOS';
import svgToDataUri from '@anm/helpers/svgToDataUri';
import { FC } from 'react';

import {
  ContentWrapper,
  DialogWrapper,
  ImageContainer,
  Message
} from './Wrapper';
import { getDownloadIcon, getIOSFilesImage } from './images';

type InfoModalProps = {
  onModalClose(): void;
};

const InfoModal: FC<InfoModalProps> = ({ onModalClose }) => {
  const action = isIOS() ? 'downloaded' : 'saved';
  const target = isIOS() ? 'Files' : 'Uploads';
  const message = `Once the file is ${action}, <br> you'll find it in <b>${target}</b>`;

  return (
    <DialogWrapper {...{ onModalClose }}>
      <ContentWrapper>
        <ImageContainer>
          <img src={`${svgToDataUri(getDownloadIcon())}`} alt="download icon" />
        </ImageContainer>
        <Message dangerouslySetInnerHTML={{ __html: message }} />
        {isIOS() && <img src={`${getIOSFilesImage()}`} alt="ios files" />}
      </ContentWrapper>
    </DialogWrapper>
  );
};

export default InfoModal;
